var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "bg-greige p-1 mb-1" }, [
    _c("p", { staticClass: "small m-0 p-0" }, [
      _c("strong", [_vm._v(_vm._s(_vm.title))]),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "small m-0 p-0" }, [
      _c("span", {
        domProps: { innerHTML: _vm._s(_vm.promotionPrice + "/mois") },
      }),
      _vm._v(" "),
      _vm.promotionType === "PROMO_DURATION"
        ? _c("span", [
            _vm._v(
              "\n            pendant " +
                _vm._s(_vm.promotionDuration) +
                " mois puis\n            "
            ),
            _c("strong", {
              domProps: { innerHTML: _vm._s(_vm.initialPrice + "/mois") },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.promotionType === "END_OF_PROMO"
        ? _c("span", [
            _vm._v("\n            puis\n            "),
            _c("strong", {
              domProps: { innerHTML: _vm._s(_vm.initialPrice + "/mois") },
            }),
            _vm._v("\n            à la fin de vos promotions\n        "),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }